

















import { Component, Vue, Prop } from 'vue-property-decorator'
import { Icon } from '@alpha/ink'
import * as ui from '@/types/frontend'

export function normalizeSearchTerm (searchTerm: string) {
  return searchTerm.toLowerCase().trim()
}

@Component({
  components: {
    Icon
  }
})

export default class FilterBar extends Vue {
  @Prop({ required: true }) private searchItem!: ui.SearchItem
  @Prop({ default: false }) readonly fitParent!: boolean

  handleInput (searchTerm: string) {
    this.$emit('change', {
      ...this.searchItem.filter,
      searchTerm
    })
  }
}

